module.exports = __webpack_public_path__ + "media/1.a5c041de.mp3";